import styled from "styled-components"

import { when, unless, maxWidth } from "utils"

import CountdownTimer from "components/hero/countdown"

export const Container = styled.div`
  width: 100%;
  display: ${(props) => (props.isMobile ? "none" : "flex")};
  justify-content: space-between;
  align-items: center;
  padding: 0 4rem;
  height: 6.3rem;

  ${unless("isBefore")`
    height: 8rem;
  `}

  p {
    font-size: 1.5rem;

    ${unless("isBefore")`
      font-size: 2.3rem;
      font-weight: 500;
    `}
  }

  background: ${(props) => props.theme.component.background};
  color: ${(props) => props.theme.component.text};

  ${(props) =>
    props.theme.component.isNested &&
    `
      color: inherit;
      height: auto;
      padding: 0 0 0 4rem;
    `}

  ${maxWidth.tablet`
    padding: 0 2rem;
    display: ${(props) => (props.hideOnMobile ? "none" : "flex")};
    flex-direction: ${(props) => props.isMobile && "column"};
    height: auto;

    ${(props) =>
      props.theme.component.isNested &&
      `
      padding: 0 0 0 2rem;
    `}
  `}
`

export const Left = styled.div`
  display: flex;
  flex-grow: 1;

  > :not(:first-child) {
    display: flex;
    align-items: center;

    ${maxWidth.desktopL`
      display: none;
    `}

    &::before {
      display: block;
      content: "";
      width: 0.5rem;
      height: 0.5rem;
      margin: auto 1rem;
      background-color: #f3ac5e;
      border-radius: 50%;
    }
  }

  ${maxWidth.mobile`
    ${when("hasButton")`
      display: ${(props) => !props.isMobile && "none"};
    `}
    padding: 1rem;
    align-items: center;

    ${when("mobileLayout")`
      display: ${(props) =>
        (props.mobileLayout === "Hide On Mobile" ||
          props.mobileLayout === "Show Only Button On Mobile") &&
        "none"}
    `}
  `}
`

export const Right = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 0 0 50%;

  button {
    &:last-child {
      margin-left: ${({ hasSecondaryButton }) => (hasSecondaryButton ? "1.75rem" : "3.5rem")};
    }
    &:first-child {
      margin-left: ${({ hasSecondaryButton }) => (hasSecondaryButton ? "3.5rem" : "0rem")};
    }
  }
  ${maxWidth.tablet`
     button {
      &:first-child {
        margin-left: 0rem;
      }

      &:last-child {
        margin-left: ${({ hasSecondaryButton }) => (hasSecondaryButton ? "3.5rem" : "0rem")};
        margin-top: 0rem;
      }
    }

    width: 100%;
    flex-direction: row;
    position: ${(props) => props.isMobile && "fixed"};
    bottom: ${(props) => props.isMobile && "0"};
    background: ${(props) => props.theme.component.background};
    padding: 10px 20px;
    z-index: 5;
    flex: 0 0 100%;
    justify-content: center;

    button {
      margin-left: 0;
      width: 95%;
      padding: 8px 24px;
      height: 40px;
    }
  `}

  ${maxWidth.mobile`
    flex-direction: column;
      button{
        &:first-child {
          margin-left: 0rem
        }
        &:last-child {
          margin-left: 0rem;
          margin-top: ${({ hasSecondaryButton }) => (hasSecondaryButton ? "1rem" : "0rem")};
        }
      }
      &:last-child {
        margin-left: 0rem;
        margin-top: ${({ hasSecondaryButton }) => (hasSecondaryButton ? "1rem" : "0rem")};
      }
    }
  ${when("mobileLayout")`
    display: ${(props) => props.mobileLayout === "Hide On Mobile" && "none"}
  `}
`}
`

export const Countdown = styled(CountdownTimer)`
  flex: 0 0 45%;
  text-align: center;

  ${maxWidth.desktop`
    display: none;
  `}

  h6,
  div {
    font-size: 2.6rem;
  }

  span {
    font-size: 1rem;
  }
`
